import React from 'react';
import { useSingleEffect } from 'react-haiku';

import DayJs from 'utils/Dayjs';

import Editor from 'components/Editor';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';

import { useDocumentProfileStore } from 'store/document/useDocumentProfileStore';

const Preview = ({ tab, setTab }) => {
	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Use document's profile store
	const document = useDocumentProfileStore(state => state.document);

	return (
		<Container className="mt-4 p-4 space-y-4">
			<Title
				title={document.title}
				subtitle={DayJs(document.createdAt).format('D. MMM, YYYY')}
				className="text-2xl font-bold tracking-wide"
			/>

			<Editor
				readOnly
				path="documents"
				folder={document.slug}
				value={document.content}
			/>
		</Container>
	);
};

export default Preview;